<template>
  <div class="index">
    <h2 class="title">常德市人大常委会会议审议意见卡</h2>
    <h3 class="subtitle">
      （{{ title }}）
    </h3>
    <table border-collapse="collapse" class="unstyledTable" style="width: 100%;" border="1" cellspacing="0"
      cellpadding="10">
      <tbody>
        <tr>
          <td>姓&nbsp;&nbsp;&nbsp;&nbsp;名</td>
          <td>
            <el-input v-model="form.name" :readonly="type == 'view'" placeholder=""></el-input>
          </td>
        </tr>
        <tr>
          <td>审议时间</td>
          <td>
            <el-input v-model="form.reviewDate" :readonly="type == 'view'" placeholder=""></el-input>
          </td>
        </tr>
        <tr>
          <td colspan="2">审议议题:
            <div>
              <el-input v-model="topics" readonly type="textarea" :autosize="{ minRows: 10, maxRows: 100000 }"
                resize="none" placeholder="">
              </el-input>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="2">审议意见:
            <div>
              <el-input v-model="form.proposal" :readonly="type == 'view'" type="textarea" resize="none"
                :autosize="{ minRows: 10, maxRows: 100000 }" placeholder="">
              </el-input>
            </div>
            <!-- <div>（可另外附页）</div> -->
            <div class="qianmin">
              <div class="input-line">本人签名：<div class="times">
                  <el-input v-model="form.signature" readonly class="width100" placeholder=""></el-input>
                </div>
              </div>
              <div class="input-line">日&nbsp;&nbsp;期：<div class="times">
                  <el-input v-model.trim="form.year" :readonly="type == 'view'" placeholder=""></el-input>
                </div>年<div class="times">
                  <el-input v-model.trim="form.month" class="width40" :readonly="type == 'view'" placeholder="">
                  </el-input>
                </div>月<div class="times">
                  <el-input v-model.trim="form.day" class="width40" :readonly="type == 'view'" placeholder="">
                  </el-input>
                </div>日</div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import {
  Button,
  Input,
  Table,
  TableColumn,
  Pagination,
  Dialog,
  Form,
  FormItem,
  Row,
  Col,
  Message,
} from 'element-ui';
import storage from 'store'
import {
  // page,
  create,
  update,
  getById
} from '@/api/suggestion/index'
import {
  getById as meetDetail
} from '@/api/meet/index'
export default {
  components: {
    // UploadImg,
    [Button.name]: Button,
    [Input.name]: Input,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Pagination.name]: Pagination,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Row.name]: Row,
    [Col.name]: Col,
    [Dialog.name]: Dialog
  },
  props: {
    congressId: {
      type: String,
    },
    type: {
      type: String,
      default: ''
    },
    id: {
      type: String
    },
    show: {
      type: Boolean,
    }
  },
  data () {
    return {
      title: '',
      textarea: '',
      times: '',
      topics: '',
      form: {
        name: '',
        reviewDate: '',
        topics: '',
        proposal: '',
        signature: '',
        year: '',
        month: '',
        day: ''
      }
    }
  },
  watch: {
    show: {
      handler (val) {
        if (val) {
          this.initData();
        } else {
          this.form = {
            name: '',
            reviewDate: '',
            topics: '',
            proposal: '',
            signature: '',
            year: '',
            month: '',
            day: ''
          }
        }
      },
      immediate: true
    }
  },
  created () {
    let id = this.$route.params.id;
    meetDetail(id).then(res => {
      if (res.status === 1) {
        this.title = res.data.name;
        this.topics = res.data.topics;
      }
    })
  },
  methods: {
    initData () {
      let user = storage.get('User-Info') || {};
      if (this.type != 'add') {
        getById(this.id).then(res => {
          this.form = res.data;
        })
      } else {
        this.form.signature = user.name;
      }
    },
    submit () {
      if (!this.form.name.trim()) {
        Message.info('姓名必填');
        this.$emit('submit', false)
        return;
      }
      if (!this.form.reviewDate.trim()) {
        Message.info('审议时间必填');
        this.$emit('submit', false)
        return;
      }
      this.form.topics = this.topics
      if (!this.form.proposal.trim()) {
        Message.info('审议意见必填');
        this.$emit('submit', false)
        return;
      }
      if (!this.form.year || !this.form.month || !this.form.day) {
        Message.info('日期必填');
        this.$emit('submit', false)
        return;
      }
      this.form.congressId = this.congressId;
      if (this.type === 'add') {
        create(this.form).then(res => {
          if (res.status == 1) {
            Message.success('成功');
            this.$emit('submit', true);
          } else {
            this.$emit('submit', false)
          }
        }).catch(() => {
          this.$emit('submit', false)
        });
      } else {
        update(this.form).then(res => {
          if (res.status == 1) {
            Message.success('成功');
            this.$emit('submit', true);
          } else {
            this.$emit('submit', false)
          }
        }).catch(() => {
          this.$emit('submit', false)
        });
      }

    }
  }
}
</script>
<style scoped>
.subtitle {
  text-align: center;
  font-family: 'FZKai-Z03S';
  font-size: 21px;
  color: #000;
}

.index {
  width: 800px;
  margin: auto;
}

table {
  width: 400px;
  border-spacing: 0;
  border-collapse: collapse;
  border: 1px solid #000;
  font-size: 18px;
  font-family: '黑体';
  color: #000;
}

.el-input>>>input {
  background: none !important;
  outline: none !important;
  border: none !important;
  font-size: 18px;
  color: #000;
  font-family: '宋体';
}

.el-textarea>>>textarea {
  background: none !important;
  outline: none !important;
  border: none !important;
  font-size: 18px;
  overflow: hidden;
  color: #000;
  font-family: '宋体';
}

.title {
  text-align: center;
  font-family: 'FZXiaoBiaoSong';
  font-size: 29px;
  color: #000;
}

.input-line {
  font-family: '宋体';
}

.input-line .times {
  padding: 0 8px;
}

.input-line .el-input>>>input {
  font-size: 1.17em;
  font-weight: bold;
  padding: 0;
  height: 30px;
  text-align: center;
  color: #000;
}

.input-line .el-input {
  width: 80px;
  border-bottom: 1px solid;
  height: 30px;
  line-height: 30px;
}

.input-line {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.input-line .width40 {
  width: 40px;
}

.input-line .width100 {
  width: 100px;
}

.qianmin {
  padding: 50px 0 20px 400px;
}

/* table.unstyledTable {
}
table.unstyledTable td,
table.unstyledTable th {
  border: 1px solid #aaaaaa;
} */
</style>
